//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import headPart from "components/publicindex/head"
  import hotLeague from "components/publicindex/hot_league"
  import itemHead from "components/ItemHead"
  import hotZone from "components/publicindex/hot_zone"
  import hotArea from "views/hotArea"
  import {loader} from '../js/loader'
  import advertisement from "./advertisement.vue"
  import {wxShareConfig} from '../js/common/utils'
  import configInfo from "../configInfo.js"
  export default{
    data(){
      return {
        indexContentHeight: '',
        regionName: '',
        regionCode: '',
        controlHotArea:false
      }
    },
    mounted(){
      // if (_czc) {_czc.push(['_trackEvent', '访问页面', '名称', '首页无联赛'])}
      this.setOverFlow();
      this.getQueryParams();
      this.initWxShareConfig();
    },
    methods: {
      initWxShareConfig:function(){
        var fullPath = window.location.href;
        var shareImg = window.location.origin + configInfo.routerBase + "static/logo.png";
        wxShareConfig({
          title: '校园足球赛事系统',
          desc: '来自未来足球校园足球大数据智能赛事系统',
          link: fullPath,
          imgUrl: shareImg,
          type: 'link',
          dataUrl: ''
        }, () => {

        }, () => {

        });
      },
      getQueryParams(){
        this.regionName = this.$route.query.regionName;
        this.regionCode = this.$route.query.regionCode;
      },
      getData(regionCode, regionName){
        this.hagkHttp(this.hagkApi.getHotAreaLeagueCount(regionCode), {}).then(
          (res) => {
            if (res.status) {
              if (res.result > 0) {
                this.$router.replace({path: 'index_region', query: {regionCode: regionCode, regionName: regionName}});
              } else {
                this.regionName = regionName;
                this.controlHotArea = !this.controlHotArea;
              }
            }else{
              console.log('获取地区联赛数量失败')
            }
          },
          (err) => {
            console.log(err)
          }
        )
        this.hideLoading();
      },
      setOverFlow: function () {
        var height = document.body.clientHeight;
        this.indexContentHeight = height + 'px';
      },
      changeRegion: function (regionCode, regionName) {
        this.$vux.loading.show();
        this.getData(regionCode, regionName);
      },
      hideLoading(){
        setTimeout(() => {
          this.$vux.loading.hide();
        }, 500);
      }
    },
    components: {headPart, hotLeague, itemHead, hotZone, hotArea, advertisement}

  }



// WEBPACK FOOTER //
// ./src/views/public_index.vue